import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import LocalizedMessage from './LocalizedMessage';

export default function useConfirmation() {
  const { t } = useTranslation();
  const [pending, setPending] = useState(null);
  const resolver = useRef(null);
  const confirm = useCallback(value => new Promise(resolve => {
    if (resolver.current) { resolve(false); return; }
    resolver.current = resolve;
    setPending(value);
  }), []);
  const finish = useCallback(result => {
    const resolve = resolver.current;
    resolver.current = null;
    setPending(null);
    if (resolve) resolve(result);
  }, []);
  useEffect(() => () => { if (resolver.current) resolver.current(false); }, []);
  const confirmation = pending && (
    <Modal show onHide={() => finish(false)} centered onEntered={node => {
      node.removeAttribute('aria-hidden');
      node.setAttribute('aria-labelledby', 'interface-confirmation-title');
    }}>
      <Modal.Header>
        <Modal.Title id="interface-confirmation-title">{t('common:confirmAction')}</Modal.Title>
      </Modal.Header>
      <Modal.Body><LocalizedMessage value={pending} /></Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn manage-button manage-teal-button" onClick={() => finish(false)}>{t('common:cancel')}</button>
        <button type="button" className="btn manage-button manage-red-button" onClick={() => finish(true)}>{t('common:confirm')}</button>
      </Modal.Footer>
    </Modal>
  );
  return { confirm, confirmation };
}
